<template>
  <svg width="55"
       height="55"
       viewBox="0 0 55 55"
       fill="url(#paint0_linear_155_2308)"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M44.7083 20.125L41.6354 13.3646L34.875 10.2916L41.6354 7.21873L44.7083 0.458313L47.7812 7.21873L54.5417 10.2916L47.7812 13.3646L44.7083 20.125ZM44.7083 54.5416L41.6354 47.7812L34.875 44.7083L41.6354 41.6354L44.7083 34.875L47.7812 41.6354L54.5417 44.7083L47.7812 47.7812L44.7083 54.5416ZM20.125 47.1666L13.9792 33.6458L0.458336 27.5L13.9792 21.3541L20.125 7.83331L26.2708 21.3541L39.7917 27.5L26.2708 33.6458L20.125 47.1666Z"
      fill="url(#paint0_linear_155_2308)" />

    <defs>
      <linearGradient id="paint0_linear_155_2308"
                      x1="13.3333"
                      y1="0"
                      x2="13.3333"
                      y2="26.6667"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#59BEE5'}` : color" />
        <stop offset="1" :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#118EBE'}` : color" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#899399"
    }
  }
}
</script>
